// Authentication utility functions for localStorage management

const AUTH_STORAGE_KEY = 'userAuth';

/**
 * Get login status from localStorage
 * @returns {boolean} True if user is logged in
 */
export const isLoggedIn = () => {
  if (typeof window === 'undefined') return false;
  const authData = localStorage.getItem(AUTH_STORAGE_KEY);
  return authData !== null;
};

/**
 * Get user data from localStorage
 * @returns {object|null} User data or null if not logged in
 */
export const getUserData = () => {
  if (typeof window === 'undefined') return null;
  const authData = localStorage.getItem(AUTH_STORAGE_KEY);
  if (!authData) return null;
  try {
    return JSON.parse(authData);
  } catch (error) {
    console.error('Error parsing user data:', error);
    return null;
  }
};

/**
 * Save login data to localStorage
 * @param {object} userData - User data to save
 */
export const saveLoginData = (userData) => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(userData));
    // Dispatch custom event to notify components of login state change
    window.dispatchEvent(new Event('authStateChange'));
  } catch (error) {
    console.error('Error saving login data:', error);
  }
};

/**
 * Remove login data from localStorage (logout)
 */
export const removeLoginData = () => {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(AUTH_STORAGE_KEY);
  // Dispatch custom event to notify components of login state change
  window.dispatchEvent(new Event('authStateChange'));
};


